import {
  AsyncPipe,
  NgClass,
  NgOptimizedImage,
  SlicePipe,
  ViewportScroller,
} from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AngularDatasModule, AuthService } from '@univacity/angular/datas';
import {
  AngularUiModule,
  Menu,
  RouterFragmentService,
  ScreenSizeService,
} from '@univacity/angular/ui';
import { RoutePath, Tour } from '@univacity/shared/types';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
// import { NgxSummernoteModule } from 'ngx-summernote';
import { filter, first } from 'rxjs';
import { TourBookingSelectionComponent } from '../tour-booking-selection/tour-booking-selection.component';
import { TourSessionComponent } from '../tour-session/tour-session.component';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'un-tour-info-tabs',
  imports: [
    NgClass,
    AsyncPipe,
    SlicePipe,
    QuillViewComponent,
    AngularUiModule,
    AngularDatasModule,
    FontAwesomeModule,
    NzCollapseModule,
    NgOptimizedImage,
    TourSessionComponent,
    TourBookingSelectionComponent,
  ],
  templateUrl: './tour-info-tabs.component.html',
  styleUrls: ['./tour-info-tabs.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourInfoTabsComponent implements OnInit, AfterViewInit {
  @Input() tour: Tour;
  @ViewChild('description', { static: false })
  private descEl: ElementRef;
  @ViewChild('inclusions', { static: false })
  private inclusionsEl: ElementRef;
  @ViewChild('itinerary', { static: false })
  private itineraryEl: ElementRef;
  @ViewChild('gallary', { static: false })
  private gallaryEl: ElementRef;
  menus: Menu[] = [];
  RoutePath = RoutePath;
  faCheck = faCheck;
  faTimes = faTimes;
  maxSessions = 2;

  constructor(
    private viewportScroller: ViewportScroller,
    private route: ActivatedRoute,
    private fragmentService: RouterFragmentService,
    public screenSize: ScreenSizeService,
    public auth: AuthService
  ) {}

  ngAfterViewInit(): void {
    this.route.fragment
      .pipe(
        first(),
        filter((f) => !!f)
      )
      .subscribe(
        (fragment) => fragment && this.viewportScroller.scrollToAnchor(fragment)
      );
  }
  ngOnInit() {
    this.initMenu();
  }

  private initMenu() {
    if (this.tour.description)
      this.menus.push({
        link: [RoutePath.tours, this.tour._id || this.tour._id],
        fragment: 'description',
        text: $localize`Description`,
      });
    this.menus.push({
      link: [RoutePath.tours, this.tour._id || this.tour._id],
      fragment: 'inclusions',
      text: $localize`Inclusions`,
    });

    if (this.tour.sessions && this.tour.sessions.length)
      this.menus.push({
        link: [RoutePath.tours, this.tour._id || this.tour._id],
        fragment: 'itinerary',
        text: $localize`Itinerary`,
      });
    if (this.tour.gallary && this.tour.gallary.length)
      this.menus.push({
        link: [RoutePath.tours, this.tour._id || this.tour._id],
        fragment: 'gallary',
        text: $localize`Gallary`,
      });
  }

  @HostListener('window:scroll', ['$event'])
  private updateFragment(event: any) {
    event.preventDefault();
    if (window.pageYOffset >= this.gallaryEl?.nativeElement.offsetTop - 275) {
      this.fragmentService.fragment.next('gallary');
    } else if (
      window.pageYOffset >=
      this.itineraryEl?.nativeElement.offsetTop - 145
    ) {
      this.fragmentService.fragment.next('itinerary');
    } else if (
      window.pageYOffset >=
      this.inclusionsEl?.nativeElement.offsetTop - 145
    ) {
      this.fragmentService.fragment.next('inclusions');
    } else if (
      window.pageYOffset >=
      this.descEl?.nativeElement.offsetTop - 145
    ) {
      this.fragmentService.fragment.next('description');
    }
  }
}
